import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PageFilterConfig } from '@gspwidget/util';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'lib-page-filter',
  templateUrl: './page-filter.component.html',
  styleUrls: ['./page-filter.component.scss']
})
export class PageFilterComponent implements OnInit {

  @Input() filters?: PageFilterConfig[]
  @Output() valueChange = new EventEmitter()

  constructor(
    public translate: TranslateService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
  }

  /** 把 filter 发来的结果值，加上 dpId 一起包装为 dpValues 发出去 */
  handleFilterSingleChange(value, filter: PageFilterConfig) {
    // 1. 普通：发出对应 1 个 dp 的单个值
    this.valueChange.emit({ filter, value })
  }
  handleFilterMultiChange(value: any[], filter: PageFilterConfig) {
    // TODO: 待实现
    this.valueChange.emit({ filter, value })

    // let dpValues
    // // 2. 日期范围：发出对应 2 个 dp 的 2 个值
    // if (ifFsDateRange(fc.fs)) {
    //   dpValues = [
    //     { value: values[0], dpId: fc.dpId },
    //     { value: values[1], dpId: fc.dpId2 },
    //   ]
    // } else {
    //   // 3. 枚举多选：发出对应 1 个 dp 的多个值
    //   dpValues = [{
    //     // TODO: 多值的连接方式是否可配？
    //     value: values.join(','), dpId: fc.dpId
    //   }]
    // }
    // this.valueChange.emit(dpValues)
  }
}
